import styled from 'styled-components';
import { Container, Col, Button } from 'react-bootstrap';
import { PRIMARY_LIGHT, BLACK, HOVER_ITEM_COLOR, PRIMARY, WHITE } from '../../utils/colors';
import HeroBg from '../../assets/hero-bg.png';

export const HeroWrapper = styled(Container)`
  color: ${WHITE};
  font-family: 'Figtree', sans-serif;

  @media (max-width: 800px) {
    text-align: center;
  }
`;

export const HeroTextCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url(${HeroBg});
  background-size: cover;
  padding: 0 30px;

  @media (max-width: 1200px) {
    padding: 30px;
  }

  @media (max-width: 800px) {
    width: 100%;
    align-items: center;
    order: 2;
  }
`;

export const HeroImageCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  @media (max-width: 800px) {
    width: 100%;
    order: 1;
  }

  img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

export const HeroTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  font-family: 'FigtreeBold', sans-serif;
  margin-bottom: 1rem;

  @media (max-width: 1200px) {
    font-size: 2rem;
  }

  @media (max-width: 800px) {
    font-size: 1.5rem;
  }
`;

export const HeroText = styled.p`
  font-size: 1rem;
  max-width: 500px;

  @media (max-width: 800px) {
    margin: 0 auto;
  }
`;

export const HeroButton = styled(Button)`
  display: block;
  font-size: inherit;
  color: ${WHITE};
  text-decoration: none;
  text-align: left;
  padding: 0.7rem 1rem;
  background-color: ${HOVER_ITEM_COLOR};
  margin-right: 10px;
  border: none;
  border-radius: 8px;
  position: relative;
  /* width: 100%; */
  font-family: 'FigtreeBold', 'sans-serif';
  transition: background-color 0.3s ease-in, color 0.3s ease-in;
  text-align: center;
  align-self: flex-start;
  margin-top: 50px;

  @media (max-width: 800px) {
    align-self: center;
  }

  &:hover, &:focus {
    color: ${WHITE};
    background-color: ${PRIMARY};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }

  &:active {
    color: ${BLACK} !important;
    background-color: ${PRIMARY} !important;
    border-color: none !important;
  }

  &:disabled {
    color: ${BLACK} !important;
    background-color: ${PRIMARY} !important;
    border-color: none !important;
  }
`